export const SET_AUTO_DEALER_PROLONGATION = 'UPDATE_AUTO_DEALER_PROLONGATION'
export const UPDATE_AUTO_DEALER_PROLONGATION = 'UPDATE_AUTO_DEALER_PROLONGATION'
export const SET_PROLONGATION = 'SET_PROLONGATION'
export const UPDATE_PROLONGATION = 'UPDATE_PROLONGATION'
